<template>
  <div class="bg-info/10 border border-info/20 text-base-content rounded-lg p-4 flex items-start gap-3 shadow-sm">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="stroke-current shrink-0 w-5 h-5 mt-0.5 text-info">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
    <div class="flex-1 text-sm leading-relaxed">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
</script>